module.exports = "pegasus_template/assets/tech/safari/101.png";